module.exports = __webpack_public_path__ + "static/TrucHuynh-236089fb4293607b0b98a7e27b231741.svg";